export default __webpack_public_path__ + "static/media/November2021.daf8a302.png";